/* src/Interviews/UpcomingInterviewsCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 49,
    overflow: 'auto',
  },
});



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/UpcomingInterviewsCard/styles.js